import React, { Component } from "react";
import { Row, Col, Card, Form, Tag } from "antd";
import { Link } from "react-router-dom";

const FormItem = Form.Item;

class CarInformation extends Component {
  render() {
    const { rawData } = this.props;

    return rawData && rawData.status.includes("SPK") ? (
      <Card title="Detail Pengajuan SPK" style={{ marginBottom: 20 }}>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col className="gutter-row" span={12}>
            <Link to={"/home/e-approval/selling-system"}>
              <p>Back to List</p>
            </Link>
          </Col>
          <Col className="gutter-row" span={12} style={{ textAlign: "right" }}>
            <Tag
              color={
                rawData.status === "SPK"
                  ? "gold"
                  : rawData.status === "SPK Reject"
                  ? "magenta"
                  : rawData.status === "Reject"
                  ? "red"
                  : rawData.status === "Cancel"
                  ? "volcano"
                  : rawData.status === "New"
                  ? "cyan"
                  : rawData.status === "Approved"
                  ? "green"
                  : "orange"
              }>
              {rawData ? rawData.status : "-"}
            </Tag>
          </Col>
        </Row>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col className="gutter-row" span={12}>
            <FormItem label="Name" style={{ marginBottom: 0 }}>
              <p>{rawData ? rawData.customerName : "-"}</p>
            </FormItem>
            <FormItem label="NIK" style={{ marginBottom: 0 }}>
              <p>{rawData ? rawData.customerNIK : "-"}</p>
            </FormItem>
            <FormItem label="NPWP" style={{ marginBottom: 0 }}>
              <p>{rawData ? rawData.customerNPWP : "-"}</p>
            </FormItem>
            <FormItem label="Mobile Phone" style={{ marginBottom: 0 }}>
              <p>+{rawData ? rawData.customerPhone : "-"}</p>
            </FormItem>
            <FormItem label="Payment Option" style={{ marginBottom: 0 }}>
              <p>
                {rawData && rawData.paymentOption ? rawData.paymentOption : "-"}
              </p>
            </FormItem>
            <FormItem label="Sales Type" style={{ marginBottom: 0 }}>
              <p>{(rawData && rawData.salesType) || "-"}</p>
            </FormItem>
          </Col>
          <Col className="gutter-row" span={12}>
            <FormItem label="Country" style={{ marginBottom: 0 }}>
              <p>{(rawData && rawData.countryName) || "-"}</p>
            </FormItem>
            <FormItem label="Province" style={{ marginBottom: 0 }}>
              <p>{(rawData && rawData.provinceName) || "-"}</p>
            </FormItem>
            <FormItem label="City" style={{ marginBottom: 0 }}>
              <p>{(rawData && rawData.cityName) || "-"}</p>
            </FormItem>
            <FormItem label="Postal Code" style={{ marginBottom: 0 }}>
              <p>{(rawData && rawData.postalCode) || "-"}</p>
            </FormItem>
            <FormItem label="Alamat" style={{ marginBottom: 0 }}>
              <p>{(rawData && rawData.customerAddress) || "-"}</p>
            </FormItem>
          </Col>
        </Row>
      </Card>
    ) : null;
  }
}

export default CarInformation;



// WEBPACK FOOTER //
// src/components/Dashboard/EApproval/Section/CarInformation.js